import { render, staticRenderFns } from "./commonImportFile.vue?vue&type=template&id=6202c253&scoped=true"
import script from "./commonImportFile.vue?vue&type=script&lang=js"
export * from "./commonImportFile.vue?vue&type=script&lang=js"
import style0 from "./commonImportFile.vue?vue&type=style&index=0&id=6202c253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202c253",
  null
  
)

export default component.exports